import {useState} from "react";
import {UnstyledButton} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {useChecklistData} from "../ChecklistDataContext";
import {CategoryOpenIcon} from "../CategoryOpenIcon";
import {renderNode} from "../../legacy/renderNodeLegacy";
import styles from "../checklist.module.css";

export const CheckItemDescription = ({
    description,
    forceExpanded,
}: {
    description: string;
    forceExpanded?: boolean;
}) => {
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const {searchTerm, topicData} = useChecklistData();

    const expanded = isOpen || forceExpanded;

    return (
        <div className={styles.descriptionSection}>
            <UnstyledButton
                className={styles.descriptionToggle}
                onClick={() => setIsOpen((prev) => !prev)}
                disabled={!!searchTerm}
            >
                <CategoryOpenIcon isOpen={expanded} />
                <span>{expanded ? t("Word.Less") : t("Word.More")}</span>
            </UnstyledButton>
            {expanded && (
                <div className={styles.contentBody}>
                    {renderNode(topicData, description, {}, description)}
                </div>
            )}
        </div>
    );
};
